import Card from '@/components/Card';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import { useStepper } from '@/features/v2/lib/stepper';
import {
  BUSINESS_ACTIVITY,
  RadioGroupBusinessActivity,
} from '@/features/v2/vehicle-damage/components/RadioGroupBusinessActivity';
import {
  RadioGroupVATTaxpayerStatus,
  VAT_PAYER_STATUS,
} from '@/features/v2/vehicle-damage/components/RadioGroupVATTaxpayerStatus';
import { RadioGroupVehicleAsFixedAsset } from '@/features/v2/vehicle-damage/components/RadioGroupVehicleAsFixedAsset';
import {
  RadioGroupVehicleUsedForBusiness,
  VEHICLE_USED_FOR_BUSINESS,
} from '@/features/v2/vehicle-damage/components/RadioGroupVehicleUsedForBusiness';
import { RadioVATDeductionPercentage } from '@/features/v2/vehicle-damage/components/RadioVATDeductionPercentage';
import { SelectBusinessType } from '@/features/v2/vehicle-damage/components/SelectBusinessType';

export const SurveyThree = () => {
  const { innerStep } = useStepper();

  return (
    <>
      {innerStep >= 0 && (
        <>
          <Card>
            <RadioGroupBusinessActivity />
            <ConditionalRender
              when={(val) => val.business_activity === BUSINESS_ACTIVITY.YES}
            >
              <RadioGroupVehicleUsedForBusiness />
              <ConditionalRender
                when={(val) =>
                  val.vehicle_used_for_business ===
                  VEHICLE_USED_FOR_BUSINESS.YES
                }
              >
                <SelectBusinessType />
                <ConditionalRender when={(val) => val.business_type}>
                  <RadioGroupVehicleAsFixedAsset />
                  <ConditionalRender when={(val) => val.vehicle_as_fixed_asset}>
                    <RadioGroupVATTaxpayerStatus />
                    <ConditionalRender
                      when={(val) =>
                        val.vat_payer_status === VAT_PAYER_STATUS.YES
                      }
                    >
                      <RadioVATDeductionPercentage />
                    </ConditionalRender>
                  </ConditionalRender>
                </ConditionalRender>
              </ConditionalRender>
            </ConditionalRender>
          </Card>
        </>
      )}
    </>
  );
};
